"use client";

import { c as _c } from "react/compiler-runtime";
import { Loader2 } from "lucide-react";
import CTAButton from "@/src/components/cta-button";
import { Button } from "@/src/components/shadcn/ui/button";

/**
 * The wizard's footer action pair: a full-width primary CTA (which owns the ⌘⏎ shortcut via
 * `CTAButton`) plus an optional full-width outline "Back". Shared by the flow footer and the review
 * step so the two never drift. Only the primary is a `CTAButton`, so the shortcut is never ambiguous.
 */
export function StepActions(t0) {
  const $ = _c(15);
  const {
    primaryLabel,
    primaryType: t1,
    form,
    onPrimary,
    primaryDisabled: t2,
    isBusy: t3,
    onBack,
    backDisabled: t4
  } = t0;
  const primaryType = t1 === undefined ? "button" : t1;
  const primaryDisabled = t2 === undefined ? false : t2;
  const isBusy = t3 === undefined ? false : t3;
  const backDisabled = t4 === undefined ? false : t4;
  const t5 = primaryDisabled || isBusy;
  let t6;
  if ($[0] !== isBusy) {
    t6 = isBusy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />;
    $[0] = isBusy;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== form || $[3] !== onPrimary || $[4] !== primaryLabel || $[5] !== primaryType || $[6] !== t5 || $[7] !== t6) {
    t7 = <CTAButton type={primaryType} form={form} onClick={onPrimary} disabled={t5} className="w-full max-w-none p-4 text-sm font-medium">{t6}{primaryLabel}</CTAButton>;
    $[2] = form;
    $[3] = onPrimary;
    $[4] = primaryLabel;
    $[5] = primaryType;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== backDisabled || $[10] !== onBack) {
    t8 = onBack && <Button variant="outline" onClick={onBack} disabled={backDisabled} className="w-full p-4 text-sm font-medium">Back</Button>;
    $[9] = backDisabled;
    $[10] = onBack;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className="space-y-2">{t7}{t8}</div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}